<template>
  <div class="delivery-address-component">
    <span class="address">{{ shortAddress }}</span>
  </div>
</template>

<script>
  export default {
    name: 'DeliveryAddress',
    props: {
      address: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      getHouse () {
        return this.address.house ? `д. ${this.address.house},` : ''
      },
      getEntry () {
        return this.address.entry ? `подъезд ${this.address.entry},` : ''
      },
      getApartment () {
        return this.address.apartmentNumber
          ? `кв. ${this.address.apartmentNumber}`
          : ''
      },
      shortAddress () {
        return this.address?.shortAddress
      },
    },
  }
</script>

<style lang="less" scoped>
.delivery-address-component {
  border-radius: 10px;
  background-color: #fff3d6;
  padding: 9px 16px;
  margin-bottom: 14px;

  .sub-title {
    display: block;
    font-size: 12px;
    line-height: 21px;
    color: #7b7b7b;
  }

  .address {
    font-size: 14px;
    line-height: 1.23;
    .media-xl({
      font-size: 15px;
    })
  }
}
</style>
